module.exports = __webpack_public_path__ + "media/images/social/hero-030c2b9941e5bc429c99cea7ecb4284e.jpg";